<template>
    <div class="backtest_analysis">
        <div class="backtest_analysis_title">
            <p>回测分析
                <vue-notice-tip :list="noticeList"></vue-notice-tip>
            </p>
        </div>
        <div class="backtest_analysis_main">
            <div class="rolltable">
                <table cellspacing="0">
                    <thead>
                         <th v-if="transactiontype === '2'">择时条件</th>
                         <th></th>
                         <th>持有期</th>
                         <th>单次收益平均值</th>
                         <th>预期年化收益率</th>
                         <th>盈亏比</th>
                         <th>成功率</th>
                         <th>最大回撤</th>
                         <th>夏普比率</th>
                         <th>单次最大收益值</th>
                         <th>单次收益最小值</th>
                         <th>周战胜率</th>
                         <th>交易次数</th>
                    </thead>

                    <tbody v-if="transactiontype === '1'">
                        <tr v-for="(back, index) in backtestData" :class="[(index + 1) % 2 === 0 ? 'gray' : '', back.daySaleStrategy === maxWinrateDay ? 'blue' : back.daySaleStrategy === maxAnnualyieldDay ? 'blue' : '']">
                            <td :class="back.daySaleStrategy === maxWinrateDay ? 'recommend' : back.daySaleStrategy === maxAnnualyieldDay ? 'recommend' : 'transparent'">荐</td>
                            <td>{{ back.daySaleStrategy }}天</td>
                            <td>{{ back.averageIncome | safePercentFixedTwo }}</td>
                            <td>{{ back.annualYield | safePercentFixedTwo}}</td>
                            <td>{{ back.averageLossRatio | safeFloatFixedTwo }}</td>
                            <td>{{ back.winRate | safePercentFixedTwo }}</td>
                            <td>{{ back.maxDrawDown | safePercentFixedTwo }}</td>
                            <td>{{ back.sharpeRatio | safeFloatFixedTwo }}</td>
                            <td>{{ back.maxIncome | safePercentFixedTwo }}</td>
                            <td>{{ back.minIncome | safePercentFixedTwo }}</td>
                            <td>{{ back.weekWinRate | safePercentFixedTwo }}</td>
                            <td>{{ back.totalTradeTimes | safeNumber }}</td>
                        </tr>
                    </tbody>

                    <tbody v-else>
                        <template v-if="item && item.length !== 0" v-for="(item, index) in backtestData">

                            <tr :class="[trBorderClass(index, item[0].daySaleStrategy, 0 === item.length - 1)]">
                                <td class="menv-border" :rowspan="item.length">{{ signalData[index] }}</td>
                                <td :class="tdBorderClass(index, item[0].daySaleStrategy)">荐</td>
                                <td>{{ item[0].daySaleStrategy }}天</td>
                                <td>{{ item[0].averageIncome | safePercentFixedTwo }}</td>
                                <td>{{ item[0].annualYield | safePercentFixedTwo}}</td>
                                <td>{{ item[0].averageLossRatio | safeFloatFixedTwo }}</td>
                                <td>{{ item[0].winRate | safePercentFixedTwo }}</td>
                                <td>{{ item[0].maxDrawDown | safePercentFixedTwo }}</td>
                                <td>{{ item[0].sharpeRatio | safeFloatFixedTwo }}</td>
                                <td>{{ item[0].maxIncome | safePercentFixedTwo }}</td>
                                <td>{{ item[0].minIncome | safePercentFixedTwo }}</td>
                                <td>{{ item[0].weekWinRate | safePercentFixedTwo }}</td>
                                <td>{{ item[0].totalTradeTimes | safeNumber }}</td>
                            </tr>

                            <tr v-if="itemIndex > 0" v-for="(back, itemIndex) in item" :class="[(itemIndex + 1) % 2 === 0 ? 'gray' : '', trBorderClass(index, back.daySaleStrategy, itemIndex === item.length - 1)]">
                                <td :class="tdBorderClass(index, back.daySaleStrategy)">荐</td>
                                <td>{{ back.daySaleStrategy }}天</td>
                                <td>{{ back.averageIncome | safePercentFixedTwo }}</td>
                                <td>{{ back.annualYield | safePercentFixedTwo }}</td>
                                <td>{{ back.averageLossRatio | safeFloatFixedTwo }}</td>
                                <td>{{ back.winRate | safePercentFixedTwo }}</td>
                                <td>{{ back.maxDrawDown | safePercentFixedTwo }}</td>
                                <td>{{ back.sharpeRatio | safeFloatFixedTwo }}</td>
                                <td>{{ back.maxIncome | safePercentFixedTwo }}</td>
                                <td>{{ back.minIncome | safePercentFixedTwo }}</td>
                                <td>{{ back.weekWinRate | safePercentFixedTwo }}</td>
                                <td>{{ back.totalTradeTimes | safeNumber }}</td>
                            </tr>

                        </template>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                noticeList: [ '1. 根据涨跌幅和上涨概率判断可以持有多久。', '2. 当上涨概率不高时，可以参考盈亏比。' ],
                myBarOption: {
                    // barColor: '#f60', // 滚动条颜色
                    barWidth: 9, // 滚动条宽度
                    // railColor: '#f5f5f5', // 导航颜色
                    barMarginRight: 3, // 垂直滚动条距离整个容器右侧距离单位
                    // barMarginBottom: 0, // 水平滚动条距离整个容器底部距离单位
                    // barOpacityMin: 0, // 滚动条非激活状态下的透明度
                    // zIndex: 'auto', // 滚动条的z-index
                    // autohidemode: true, // 自动隐藏模式
                    horizrailenabled: false // 是否显示水平滚动条
                }
            }
        },
        computed: {
            maxAnnualyieldDay () {
                if (this.maxAnnualyield.length !== 0) {
                    return this.transactiontype === '1' ? this.maxAnnualyield[1] : this.maxAnnualyield[2]
                }
            },
            maxWinrateDay () {
                if (this.maxWinrate.length !== 0) {
                    return this.transactiontype === '1' ? this.maxWinrate[1] : this.maxWinrate[2]
                }
            }
        },
        props: {
            backtestData: {
                type: [Array, Object],
                default () {
                    return []
                }
            },
            transactiontype: String,
            signalData: Object,
            maxWinrate: {
                type: [Array, Object],
                default () {
                    return []
                }
            },
            maxAnnualyield: {
                type: [Array, Object],
                default () {
                    return []
                }
            }
        },
        methods: {
            trBorderClass (signal, day, isLast) {
                if (this.isRecommend(signal, day)) {
                    return 'blue'
                } else if (isLast) {
                    return 'thin-blue'
                } else {
                    return ''
                }
            },
            tdBorderClass (signal, day) {
                return this.isRecommend(signal, day) ? 'recommend' : 'transparent'
            },
            isRecommend (signal, day) {
                return (signal === this.maxWinrate[1] && day === this.maxWinrateDay) ||
                    (signal === this.maxAnnualyield[1] && day === this.maxAnnualyieldDay)
            }
        }
    }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    @import '../../scss/strategybacktest/backtest_analysis.scss';
</style>



// WEBPACK FOOTER //
// src/components/strategybacktest/backtest-analysis.vue